export default __webpack_public_path__ + "media/images/please-login-40fb22b5.jpg";